/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserWalletInfoRespVo
 */
export interface UserWalletInfoRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof UserWalletInfoRespVo
     */
    id?: number;
    /**
     * 用户 ID，关联用户表主键
     * @type {number}
     * @memberof UserWalletInfoRespVo
     */
    userId?: number;
    /**
     * 钱包类型：1-韩国钱包，2-中国账单钱包
     * @type {number}
     * @memberof UserWalletInfoRespVo
     */
    walletType?: number;
    /**
     * 钱包余额
     * @type {number}
     * @memberof UserWalletInfoRespVo
     */
    amount?: number;
    /**
     * 货币代码，如 CNY、USD、KRW 等
     * @type {string}
     * @memberof UserWalletInfoRespVo
     */
    currencyCode?: string;
    /**
     * 冻结金额
     * @type {number}
     * @memberof UserWalletInfoRespVo
     */
    freezeAmount?: number;
    /**
     * 透支额度
     * @type {number}
     * @memberof UserWalletInfoRespVo
     */
    overdraftLimit?: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof UserWalletInfoRespVo
     */
    enable?: number;
    /**
     * 是否删除：0-未删除，1-已删除
     * @type {number}
     * @memberof UserWalletInfoRespVo
     */
    deleteStatus?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof UserWalletInfoRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof UserWalletInfoRespVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the UserWalletInfoRespVo interface.
 */
export function instanceOfUserWalletInfoRespVo(value: object): value is UserWalletInfoRespVo {
    return true;
}

export function UserWalletInfoRespVoFromJSON(json: any): UserWalletInfoRespVo {
    return UserWalletInfoRespVoFromJSONTyped(json, false);
}

export function UserWalletInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWalletInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'walletType': json['walletType'] == null ? undefined : json['walletType'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'freezeAmount': json['freezeAmount'] == null ? undefined : json['freezeAmount'],
        'overdraftLimit': json['overdraftLimit'] == null ? undefined : json['overdraftLimit'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'deleteStatus': json['deleteStatus'] == null ? undefined : json['deleteStatus'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function UserWalletInfoRespVoToJSON(json: any): UserWalletInfoRespVo {
    return UserWalletInfoRespVoToJSONTyped(json, false);
}

export function UserWalletInfoRespVoToJSONTyped(value?: UserWalletInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'walletType': value['walletType'],
        'amount': value['amount'],
        'currencyCode': value['currencyCode'],
        'freezeAmount': value['freezeAmount'],
        'overdraftLimit': value['overdraftLimit'],
        'enable': value['enable'],
        'deleteStatus': value['deleteStatus'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

